// extracted by mini-css-extract-plugin
export default {"empty":"tax-information_empty__Os87g"};